import { call, put, takeEvery } from 'redux-saga/effects';
import { changeManagerLeadStatus } from '../../requests/lead_manager_lead_status_request';
import {
    leadManagerChangeLeadsStatusRequestSuccess,
    leadManagerChangeLeadsStatusRequestFailure,
} from '../actions/lead_manager_lead_status.actions';
import { LEAD_MANAGER_CHANGE_LEADS_STATUS_REQUEST } from '../constants/lead_manage_leads_status.constants';

function* changeManagerLeadStatusRequest({ id, shouldKill, margin }) {
    const leadStatus = yield call(changeManagerLeadStatus, id, shouldKill, margin);

    if (leadStatus.result) {
        yield put(leadManagerChangeLeadsStatusRequestSuccess(leadStatus.options));
    } else {
        yield put(leadManagerChangeLeadsStatusRequestFailure(leadStatus.error));
    }
}

export default function* changeManagerLeadStatusSaga() {
    yield takeEvery(LEAD_MANAGER_CHANGE_LEADS_STATUS_REQUEST, changeManagerLeadStatusRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/redux/sagas/lead_manager_get_lead_status.saga.js